export default [
    {
        path: "/payments/transactions",
        name: "payments-transactions",
        meta: { title: "Payments Transactions", authRequired: true },
        component: () => import("../views/payments/transactions/transactions.vue"),
    },
    {
        path: "/payments/transactions/:ptn",
        name: "transaction-details",
        meta: { title: "Transaction Details", authRequired: true },
        component: () => import("../views/payments/transactions/transaction-details.vue"),
    },
    {
        path: "/payments/manage/providers",
        name: "payment-providers",
        meta: { title: "Payment Providers", authRequired: true },
        component: () => import("../views/payments/providers/providers.vue"),
    },
    {
        path: "/payments/manage/providers/new",
        name: "new-payment-provider",
        meta: { title: "New Payment Provider", authRequired: true },
        component: () => import("../views/payments/providers/new-provider.vue"),
    }
]